export default __webpack_public_path__ + "static/media/icons-project-delivery.bb1e99aa.svg";